import { render, staticRenderFns } from "./task-user-agreement-popup.html?vue&type=template&id=44495127&scoped=true&external"
import script from "./task-user-agreement-popup.js?vue&type=script&lang=js&external"
export * from "./task-user-agreement-popup.js?vue&type=script&lang=js&external"
import style0 from "./task-user-agreement-popup.scss?vue&type=style&index=0&id=44495127&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44495127",
  null
  
)

export default component.exports